module.exports = __webpack_public_path__ + "img/5 - 3 - 2.83fd1aa7.jpg";